import colorMod from 'color';
import { get } from 'lodash';

export default ({ color, fontSize, typography }) => ({
  HeaderRequestsButton: {
    display: 'inline-block',
    marginRight: 8,
    '& button': {
      padding: 8,
      color: get(color, 'headerLink'),
      border: '1px solid',
      borderRadius: 3,
      borderColor: 'rgba(0, 0, 0, 0)',
      '&:hover': {
        color: colorMod(get(color, 'headerLink')).alpha(0.7).string(),
        backgroundColor: 'rgba(0, 0, 0, 0)',
      },
      '&:focus': {
        borderColor: colorMod(get(color, 'headerLink')).alpha(0.7).string(),
      },
      '&:active': {
        borderColor: get(color, 'headerLink'),
      },
    },
    '.skipPrint &': {
      '@media print': {
        display: 'none',
      },
    },
  },
  WarningIcon: {
    width: 24,
    height: 24,
    color: get(color, 'warning'),
  },
  NotificationsIcon: {
    width: 24,
    height: 24,
    color: get(color, 'success'),
  },

  success: {
    color: get(color, 'success'),
  },

  error: {
    color: '#808080',
  },

  BadgePrimary: {
    backgroundColor: get(color, 'danger'),
    color: '#FFFFFF',
    fontFamily: get(typography, 'bodyText'),
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
  },

  BadgeWarning: {
    backgroundColor: get(color, 'warning'),
    color: '#FFFFFF',
    fontFamily: get(typography, 'bodyText'),
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
  },

  Popper: {
    marginTop: 4,
  },

  MenuPaper: {
    borderRadius: 3,
    boxShadow: 'none',
    filter: 'drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))',
  },

  Menu: {
    fontFamily: get(typography, 'bodyText'),
    margin: '0 0 0 0 !important',
    maxHeight: '500px',
    overflowY: 'auto',
    width: '280px',
    color: `${colorMod(get(color, 'link'))} !important`,
  },

  HeaderRequestsMenuItem: {
    borderLeft: '3px solid !important',
    borderColor: 'rgba(0, 0, 0, 0) !important',
    color: `${get(color, 'link')} !important`,
    display: 'inline-block',
    fontSize: `${get(fontSize, 'bodyText')}`,
    overflow: 'hidden',
    padding: '0px 0px 0px 0px !important',
    textDecoration: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '205px',
    '& a': {
      color: `${get(color, 'bodyText')} !important`,
      fontSize: `${get(fontSize, 'bodyText')} !important`,
      fontFamily: `${get(typography, 'bodyText')} !important`,
      fontStyle: 'normal !important',
      fontWeight: 'normal !important',
      textDecoration: 'none !important',
    },
  },

  Capitalize: {
    textTransform: 'capitalize',
  },

  HeaderRequestsNoRequestsIcon: {
    color: `${get(color, 'headerLink')} !important`,
    display: 'inline-block',
    height: '24px',
    margin: '0 auto',
    paddingBottom: '6px',
    paddingTop: '6px',
    textAlign: 'center',
    width: '100%',
  },

  NoRequestsIcon: {
    height: '24px !important',
    width: '24px !important',
  },

  title: {
    color: `${get(color, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'smallText')} !important`,
    margin: '0 auto !important',
    padding: '20px 10px 10px 15px',
  },

  message: {
    color: `${get(color, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    margin: '0 auto',
    padding: '10px 15px 15px 15px',
  },

  SubHeaderUppercase: {
    color: `${get(color, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'smallText')} !important`,
    fontStyle: 'normal !important',
    fontWeight: 'bold !important',
    lineHeight: '36px !important',
    opacity: '1.0 !important',
    padding: '0 12px 0 12px !important',
    textDecoration: 'none',
    textTransform: 'uppercase',
  },
  count: {
    float: 'right',
    marginRight: '35px',
    marginTop: '30px',
  },
  errorText: {
    color: `${get(color, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    fontFamily: `${get(typography, 'bodyText')} !important`,
    padding: '0px',
    display: 'block',
    whiteSpace: 'normal',
  },
  menuItemRoot: {
    display: 'inline-block',
    width: '240px',
    '&.MuiListItem-button:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  menuContainer: {
    '&:hover': {
      backgroundColor: `${colorMod(get(color, 'headerLink')).alpha(0.10).string()} !important`,
    },
    '&:focus': {
      backgroundColor: `${colorMod(get(color, 'headerLink')).alpha(0.08).string()} !important`,
      borderColor: `${get(color, 'headerLink')} !important`,
      outline: 'none !important',
    },
  },
});
